import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { SearchX } from "lucide-react";

export function NotFound() {
  return (
    <div className="flex min-h-[60vh] items-center justify-center">
      <Card className="max-w-md w-full">
        <CardContent className="py-12 text-center">
          <SearchX className="mx-auto h-16 w-16 text-muted-foreground/40" />
          <h1 className="mt-6 text-2xl font-semibold">Página no encontrada</h1>
          <p className="mt-2 text-muted-foreground">
            La página que buscas no existe o fue movida.
          </p>
          <Button asChild className="mt-6">
            <Link to="/">Ir al Panel</Link>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
